import React from 'react';
import { Icon } from 'semantic-ui-react';
import * as classes from './classes.module.scss';

const BackButton = (props) => (
  <div className={ classes.pin }>
    <button type="button" { ...props }>
      <Icon name="chevron left" size="small" />
      BACK
    </button>
  </div>
);

export default BackButton;
